import { Box, Card, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import { Labeled } from 'react-admin';
import { Supplier } from '../order/Order.type';
import { toPriceKRW } from '../util/CommonUtils';
import { getSupplierSettlementShow } from './OrderSettlement.api';
import { OrderSettlementType } from './Settlement.type';

export default function SupplierOrderSettlementShow({
  date,
  supplier,
}: {
  date?: string;
  supplier?: Supplier;
}) {
  const [stlmt, setStlmt] = useState<OrderSettlementType>();

  useEffect(() => {
    getSupplierSettlementShow({ date, supplierId: supplier?.id }).then(
      (res) => {
        setStlmt(res.data);
      }
    );
  }, [date, supplier]);

  return (
    <Card>
      <Box sx={{ padding: 2 }}>
        <Typography
          variant='h5'
          display={'inline'}
        >{`${stlmt?.year}년`}</Typography>
        <Typography
          variant='h5'
          display={'inline'}
          marginLeft={1}
        >{`${stlmt?.month}월`}</Typography>
        {supplier && (
          <Typography display={'inline'} marginLeft={2} variant='h5'>
            {supplier?.name}
          </Typography>
        )}
        <Box>
          <Labeled
            label={`총 수량`}
            children={<>{stlmt?.totalAmountForMonth}</>}
          />
        </Box>
        <Box>
          <Labeled
            label={`합산 금액`}
            children={<>{toPriceKRW(stlmt?.totalDisplayGrossPrice)}</>}
          />
        </Box>
      </Box>
    </Card>
  );
}
